import { c as _c } from "react/compiler-runtime";
import { IcoDotsHorizontal16 } from '@onefootprint/icons';
import type { OrganizationRole } from '@onefootprint/request-types/dashboard';
import { Dropdown, IconButton } from '@onefootprint/ui';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import type { EditHandler } from './components/edit-dialog';
import Edit from './components/edit-dialog';
import type { RemoveHandler } from './components/remove';
import Remove from './components/remove';
export type ActionsProps = {
  role: OrganizationRole;
};
const Actions = t0 => {
  const $ = _c(35);
  const {
    role
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "table.actions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("roles", t1);
  const [openDropdown, setOpenDropdown] = useState(false);
  const removeRef = useRef(null);
  const editRef = useRef(null);
  const {
    name
  } = role;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      event.preventDefault();
      editRef.current?.edit();
      setOpenDropdown(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleEdit = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event_0 => {
      event_0.preventDefault();
      removeRef.current?.remove();
      setOpenDropdown(false);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleRemove = t3;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp3);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== name || $[6] !== t) {
    t5 = t(_temp4, {
      name
    });
    $[5] = name;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Dropdown.Trigger asChild={true}><div><IconButton aria-label={t5} size="tiny" icon={IcoDotsHorizontal16} className="max-md:size-10" /></div></Dropdown.Trigger>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <PermissionGate scopeKind="org_settings" fallbackText={t4}>{t6}</PermissionGate>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp5);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Dropdown.Item onSelect={handleEdit}>{t8}</Dropdown.Item>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t(_temp6);
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <Dropdown.Item onSelect={handleRemove} destructive={true}>{t10}</Dropdown.Item>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <Dropdown.Portal><Dropdown.Content align="end"><Dropdown.Group>{t9}{t11}</Dropdown.Group></Dropdown.Content></Dropdown.Portal>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== openDropdown || $[25] !== t12 || $[26] !== t7) {
    t13 = <Dropdown.Root open={openDropdown} onOpenChange={setOpenDropdown}>{t7}{t12}</Dropdown.Root>;
    $[24] = openDropdown;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  let t15;
  if ($[28] !== role) {
    t14 = <Remove role={role} ref={removeRef} />;
    t15 = <Edit role={role} ref={editRef} />;
    $[28] = role;
    $[29] = t14;
    $[30] = t15;
  } else {
    t14 = $[29];
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t13 || $[32] !== t14 || $[33] !== t15) {
    t16 = <div className="flex justify-end" onClick={_temp} onKeyDown={_temp2}>{t13}{t14}{t15}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
export default Actions;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  if (e_0.key === "Enter" || e_0.key === " ") {
    e_0.stopPropagation();
  }
}
function _temp3($) {
  return $.notAllowed;
}
function _temp4($_0) {
  return $_0.ariaLabel;
}
function _temp5($_1) {
  return $_1.edit;
}
function _temp6($_2) {
  return $_2.remove;
}